// Grand staff geometry. Diatonic positions counted as half-line-spacing steps.
// We anchor the top treble line F5 and compute Y for every note from there.

export const LINE_SPACING = 14;     // px between adjacent staff lines
export const HALF_STEP = LINE_SPACING / 2; // px per diatonic step

export const STAFF_TOP_Y = 60;     // Y of the top treble line (F5)

const DIATONIC = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];

// Absolute diatonic index across octaves. C0 = 0.
function diatonicIndex(note, octave) {
  return octave * 7 + DIATONIC.indexOf(note);
}

const F5_INDEX = diatonicIndex('F', 5);

export function noteToY(note, octave) {
  const stepsDown = F5_INDEX - diatonicIndex(note, octave);
  return STAFF_TOP_Y + stepsDown * HALF_STEP;
}

// Staff line Y coordinates
export const TREBLE_LINES = [
  noteToY('F', 5),
  noteToY('D', 5),
  noteToY('B', 4),
  noteToY('G', 4),
  noteToY('E', 4),
];

export const BASS_LINES = [
  noteToY('A', 3),
  noteToY('F', 3),
  noteToY('D', 3),
  noteToY('B', 2),
  noteToY('G', 2),
];

export const MIDDLE_C_Y = noteToY('C', 4);

// Determines ledger lines required to reach a note on the grand staff.
// Returns Y coordinates of ledger lines to draw at the given x.
export function ledgerLinesFor(note, octave) {
  const targetY = noteToY(note, octave);
  const lines = [];
  // Above treble (F5 line at STAFF_TOP_Y)
  if (targetY < STAFF_TOP_Y) {
    let y = STAFF_TOP_Y - LINE_SPACING;
    while (y >= targetY - HALF_STEP * 0.5) {
      lines.push(y);
      y -= LINE_SPACING;
    }
  }
  // Below bass (G2 line)
  const bassBottom = BASS_LINES[4];
  if (targetY > bassBottom) {
    let y = bassBottom + LINE_SPACING;
    while (y <= targetY + HALF_STEP * 0.5) {
      lines.push(y);
      y += LINE_SPACING;
    }
  }
  // Between treble and bass: middle C ledger if note sits there
  if (Math.abs(targetY - MIDDLE_C_Y) < HALF_STEP * 0.6) {
    lines.push(MIDDLE_C_Y);
  }
  return lines;
}

export const STAFF_VIEWBOX = { width: 1000, height: 260 };
